// import axios from 'axios'

import Vue from 'vue'
import Vuex from 'vuex'
import axiosIns from '../libs/axios'

const ERROR_LIST = {
    'INIT_EXAM_ERROR': {
        code: "INIT_EXAM_ERROR",
        msg: "Khởi tạo đề thi thất bại, vui lòng liên hệ với quản trị viên!"
    }
}

Vue.use(Vuex)

export default new Vuex.Store({
    state: { //khai báo biến
        appSettings: {
            "start_with": {
                "type": "form_input",
                configs: {
                    form_input: [],
                    ican_connect: {}
                }
            },
            fb_tracking: '',
            theme: ''
        },
        errorCode: '',
        page: 1,
        tracking_id: localStorage.getItem('_speakup_track') || null,
        questions: null,
        part: 0,
        contactInfo: {
            id: -1,
            email: '',
            name: '',
            phone: '',
        },
        loading: false,
        exam: {
            id: -1,
            time: {},
            part: 0,
            data: {}
        }
    },
    getters: {
        fbTracking (state) {
            return state.appSettings.fb_tracking
        },
        startWithSettings (state) {
            return state.appSettings.start_with.configs
        },
        getStartType (state) {
            return state.appSettings.start_with.type || ''
        },
        getError(state) {
            return ERROR_LIST[state.errorCode] || {}
        },
        getQuestion(state) {
            return state.questions
        },
        getQuestionPart(state) {
            if (state.questions) {
                return state.questions.part[state.part]
            }
            return []
        },
        getExamPart(state) {
            if (state.questions) {
                return state.questions.part
            }
            return []
        },
        getPartTitle(state) {
            if (state.questions) {
                return state.questions.part[state.part].name
            }
            return ''
        },
        getWritingOfPart(state) {
            if (state.questions) {
                return state.questions.part[state.part].writing || ''
            }
            return ''
        },
        getPartNumber(state) {
            return state.part
        },
        countPart(state) {
            return state.questions.part.length
        }
    },
    mutations: { // thực hiện commit của action
        SET_ERROR_CODE(state, payload) {
            state.errorCode = payload
        },
        SET_CONTACT_INFO(state, payload) {
            state.contactInfo =  Object.assign(state.contactInfo, payload)
            localStorage.setItem('_speakup_userInfo', JSON.stringify(state.contactInfo))
        },
        SET_TIME_REMAINING(state, payload) {
            state.questions.part[state.part].time_remaining = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.questions))
        },
        SET_QUESTION_INDEX(state, payload) {
            state.questions.part[state.part].question_index = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.questions))
        },
        SET_PART_STEP(state, payload) {
            state.questions.part[state.part].step = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.questions))
        },
        SET_VIDEO_REPLAY_COUNT(state, payload) {
            state.questions.part[state.part].video_replay = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.questions))
        },
        SET_WRITING(state, payload) {
            state.questions.part[state.part].writing = payload
            localStorage.setItem('speakupTestData', JSON.stringify(state.questions))
        },
        SET_PAGE(state, payload) {
            state.page = payload;
            // Next page save test data
            // localStorage.setItem('speakupTestData', JSON.stringify(state.questions))
        },
        SET_PART(state, payload) {
            state.part = payload
            state.questions.partIsUsed = payload
        },
        SET_TRACKING_ID(state, payload) {
            state.tracking_id = payload
            localStorage.setItem('_speakup_track', payload)
        },
        SET_QUESTIONS(state, payload) {
            state.questions = payload
        },
        SET_ANSWER(state, payload) {

            const questionIndex = state.questions.part[state.part].questions.findIndex(qs => { return qs.id === payload.id })


            // part_type == 2 câu hỏi dạng speaking.

            if (state.questions.part[state.part].part_type == 2) {
                state.questions.part[state.part].questions[questionIndex].answers = payload
            } else {
                for (let index = 0; index < payload.value.length; index++) {
                    state.questions.part[state.part].questions[questionIndex].answers[index] = payload.value[index];
                }
    
                const chenhlech = state.questions.part[state.part].questions[questionIndex].answers.length - payload.value.length
                if (chenhlech > 0) {
                    state.questions.part[state.part].questions[questionIndex].answers.splice(payload.value.length, chenhlech)
                }
            }
            // state.questions.part[state.part].questions[questionIndex].answers = payload.value

            // localStorage.setItem('speakupTestData', JSON.stringify(state.questions))
        },
        PAGE_LOADING(state, payload) {
            state.loading = payload
        },


        // lưu id bài làm vào localStore
        SET_EXAM_ID (state, examId) {
            state.exam.id = examId
            localStorage.setItem(`_speakup_exam${state.questions.id}`, examId)
        },

        SET_EXAM_PART (state, part) {
            state.exam.part = part
        },


        SET_SETTINGS(state, settings) {
            state.appSettings = settings
        }
    },
    actions: {



        // Huy thong tin bai lam
        // Trong truong hop khong lam tiep bai thi nua

        doNotContinueTest({commit, state}) {

            if (state.exam.id) {

                commit('SET_PART', 0)

                axiosIns.post(axiosIns.ENDPOINT.TEST_DONE, {
                    id: state.exam.id
                })
                .then(resp => {
                    if (resp.data.code === 1) {
                        //
                    } else {
                        //
                    }
                })

                localStorage.removeItem(`_speakup_exam${state.questions.id}`)
            }

        },

        Questions({ commit }, payload) {
            commit('SET_QUESTIONS', payload)
        },

        /**
         * Tiep tuc lam bai thi
         */
        TestContinue({ commit }, testData) {
            // Page 2 - quy định làm bài
            commit('SET_PAGE', 2)

            if (!testData) {
                commit('SET_PART', 0)
            } else {
                //
            }
        },


        /**
         * Tìm nạp thông tin bài làm localstorage
         */

        fetchTestInfo ({state, commit}) {
            return new Promise ((resolve) => {
                if (state.questions.id) {
                    const testId = localStorage.getItem(`_speakup_exam${state.questions.id}`)

                    if (testId) {
                        commit('SET_EXAM_ID', testId)
                        return resolve(true)
                    }
                }

                return resolve(false)
            })
        },
        

        /**
         * Tìm nạp userinfo trong localstorage
         */

        fetchUserInfo ({commit}) {
            return new Promise ((resolve) => {
                const localUserInfo = localStorage.getItem('_speakup_userInfo')
                let userData = {}
                if (localUserInfo) {
                    userData = JSON.parse(localUserInfo)
                }

                userData.source = document.location.href

                commit('SET_CONTACT_INFO', userData)

                resolve(true)
            })
        },

        /**
         * TrackingID
         */
        Tracking_init({ commit }) {

            return new Promise ((resolve, reject) => {
                let trackid = localStorage.getItem('_speakup_track');
                if (!trackid) {
                    axiosIns.get(axiosIns.ENDPOINT.INIT_TRACKID)
                    .then(resp => {
                        if (resp.data.code === 1) {
                            trackid = resp.data.data
                            commit('SET_TRACKING_ID', trackid)
                            resolve(trackid)
                        } else {
                            reject(false)
                        }
                    })
                    .catch(() => {
                        reject(false)
                    })                 
                } else {
                    commit('SET_TRACKING_ID', trackid)
                    resolve(trackid)
                }
            })
            
        },


        AuthLogout() {

        },

        /**
         * Lấy đề không dùng trackingId
         * Đề được lấy được config trước tương ứng với trang
         *  
         */
        fetchExam ({ state, commit }, payload) {
            
            const {examId, examSlug} = payload
            const formData = {
                tracking_id: state.tracking_id,
            }

            if (examId || examSlug) {
                formData.target = examId ?? examSlug

                if (examId) {
                    formData.type = 'exam_id'
                }

                if (examSlug) {
                    formData.type = 'exam_slug'
                }
            }

            return new Promise( (resolve, reject) => {
                axiosIns.get(axiosIns.ENDPOINT.GET_EXAM, {
                    params:formData
                }).then(resp => {

                    if (resp.data.code == 1) {

                        commit('SET_QUESTIONS', resp.data.data)

                        return resolve(resp.data)
                    } else {
                        return reject(false)
                    }
                })
                .catch (error => {
                    return reject(error)
                }) 
            })
        },


        /**
         * Tìm bài làm chưa xong với đề tương ứng
         */

        checkExamPending ({state, commit}) {
            return new Promise ((resolve, reject) => {
                if(state.contactInfo.id != -1 && state.exam.id != -1) {
                    axiosIns.get(axiosIns.ENDPOINT.GET_EXAM_HISTORY, {
                        params: {
                            trackid: state.tracking_id,
                            id: state.exam.id,
                            cid: state.contactInfo.id
                        }
                    }).then (resp => {
                        if (resp.data.code === 1) {
                            
                            const testData = resp.data.data

                            // Truong hop bai test chua hoan thanh hoac khong co
                            if (testData.status == 0) {
                                if (testData.test_result != null) {
                                    if (testData.test_result.partIsUsed) {
                                        commit('SET_PART', testData.test_result.partIsUsed)
                                    }
                                }
    
                                return resolve(testData.test_result)
                            } 
                            
                            // Bai thi da hoan thanh
                            else {
                                localStorage.removeItem(`_speakup_exam${state.questions.id}`)
                                return resolve(false)
                            }
                            
                        } else {
                            return resolve(false)
                        }
                    })
                    .catch (error => {
                        return reject('checkExamPending', error)
                    })
                } else {
                    return resolve(false)
                }
            })
        },


        /**
         * Tao bai lam
         */

        createTest ({state, commit}) {
            return new Promise ((resolve, reject) => {
                axiosIns.post(axiosIns.ENDPOINT.TEST_CREATE, {
                    tracking_id: state.tracking_id,
                    exam_id: state.questions.id,
                })
                .then(resp => {
                    if (resp.data.code === 1 ) {
                        
                        commit('SET_EXAM_ID', resp.data.data)

                        return resolve(resp.data.data)
                    } else {
                        return reject('createTest', false)
                    }
                })
                .catch(error => {
                    return reject('createTest', error)
                })
            })
        },



        pushContact({commit, state}, payload) {
            return new Promise((resolve, reject) => {

                const storeUserInfo = Object.assign(state.contactInfo, payload)

                axiosIns.post(axiosIns.ENDPOINT.PUSH_CONTACT, {
                    trackid: state.tracking_id,
                    data: storeUserInfo
                })
                .then(resp => {
                    if (resp.data.code == 1) {
                        const userInfo = Object.assign(payload, {id: resp.data.data})
                        commit('SET_CONTACT_INFO', userInfo)

                        return resolve(userInfo)
                    } else {
                        resolve(false)
                    }
                })
                .catch(error => {
                    reject('pushContact', error)
                })
            })
        },


        /**
         * Save test
         */

        TestSave({state}, payload) {
            
            return new Promise((resolve, reject) => {
                axiosIns.post(axiosIns.ENDPOINT.TEST_SAVE, {
                    trackid: state.tracking_id,
                    test_data: state.questions,
                    test_id: state.exam.id
                }, {
                    page_overlay: payload ? payload.overlay || false : false
                })
                .then(res => {
                    if (res.data.code === 1) {
                        return resolve(true)
                    } else {
                        return reject(res.data.message)
                    }
                })
                .catch (error => {
                    return reject(error.message)
                })
            })
        },


        userClearInfo ({commit}) {
            this._vm.$cookie.delete('access_token')
            commit('SET_CONTACT_INFO', {
                id: -1,
                email: '',
                name: '',
                phone: '',
            })
        },

        AuthCheck ({ commit, dispatch }) {
            const accessToken = this._vm.$cookie.get('access_token')
        
            if (accessToken) {
                axiosIns.get('/GEauth/userinfo', {
                    headers: {
                        'authorization': 'Bearer ' + accessToken
                    }
                }).then(res => {
                    if (res.data.code == 1) {
                        this._vm.$cookie.set('ctid', res.data.data.id)
                        commit('SET_CONTACT_INFO', {
                            id: res.data.data.id,
                            email: res.data.data.email,
                            name: res.data.data.displayName
                        })
                    } else {
                        dispatch('AuthLogout')
                    }
        
                })
            } else {
                dispatch('AuthLogout')
            }
        },
    },
    modules: {
        // auth: moduleAuth,
        // campaign: modulCampaign
    },
    strict: process.env.NODE_ENV !== 'production'
})
